import React from "react";
import styles from "../Capture.module.css";

type LoaderProps = {
  message?: string;
};

const Loader: React.FC<LoaderProps> = ({ message }) => (
  <div className={styles.container}>
    <div className={styles.loader}></div>
    {message && <div style={{ marginTop: 16 }}>{message}</div>}
  </div>
);

export default Loader;
